import { useCallback, useState } from "react";
import SetState from "../typings/SetState";

const useCheckText = (setText: SetState<string>) => {
  const [error, setError] = useState(false);

  //? useCallback is used to avoid the recreation of the custom hook since setIsLoading is a function and it is recreated every time the component in which resides re-render.
  const handleTextChange = useCallback(
    (text: string, regex?: RegExp) => {
      setText(text);
      let reg = regex ? regex : /^[A-Za-z0-9]*$/;
      if (reg.test(text) === false) {
        setError(true);
      } else {
        setError(false);
      }
    },
    [setText]
  );

  return {
    error,
    setError,
    handleTextChange,
  };
};

export default useCheckText;
